const indexItems = [
  {
    icon: 'ri-star-fill',
    color: 'bg-primary-100 text-primary-600',
    title: '明星八卦',
    desc: '顶流动态 · 恋情曝光 · 私生活揭秘',
    count: '1,286条',
  },
  {
    icon: 'ri-movie-2-fill',
    color: 'bg-accent-100 text-accent-600',
    title: '影视追踪',
    desc: '新片定档 · 票房战报 · 剧透盘点',
    count: '952条',
  },
  {
    icon: 'ri-music-fill',
    color: 'bg-secondary-100 text-secondary-600',
    title: '音乐动态',
    desc: '新歌首发 · 演唱会 · 专辑测评',
    count: '743条',
  },
  {
    icon: 'ri-tv-2-fill',
    color: 'bg-primary-100 text-primary-600',
    title: '综艺热点',
    desc: '嘉宾爆料 · 名场面 · 赛制争议',
    count: '1,028条',
  },
  {
    icon: 'ri-live-fill',
    color: 'bg-accent-100 text-accent-600',
    title: '网红事件',
    desc: '翻车实录 · 流量密码 · 跨圈联动',
    count: '615条',
  },
  {
    icon: 'ri-shirt-fill',
    color: 'bg-secondary-100 text-secondary-600',
    title: '时尚潮流',
    desc: '红毯造型 · 品牌代言 · 穿搭解析',
    count: '487条',
  },
  {
    icon: 'ri-gamepad-fill',
    color: 'bg-primary-100 text-primary-600',
    title: '电竞娱乐',
    desc: '赛事热点 · 选手八卦 · 圈内动态',
    count: '534条',
  },
  {
    icon: 'ri-global-fill',
    color: 'bg-accent-100 text-accent-600',
    title: '国际瓜田',
    desc: '好莱坞 · 韩流 · 日娱动态',
    count: '391条',
  },
];

export default function IndexSection() {
  return (
    <section
      id="index"
      className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50"
      style={{ scrollMarginTop: '80px' }}
    >
      <div className="w-full max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            瓜田索引
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            按分类探索你感兴趣的娱乐热点
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item, i) => (
            <div
              key={i}
              className="group flex items-start gap-3 p-4 rounded-lg bg-background-100 border border-background-200/70 transition-colors duration-200 hover:border-primary-200 cursor-pointer"
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${item.color} flex-shrink-0 transition-transform duration-200 group-hover:scale-110`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.count}</span>
                </div>
                <p className="text-xs text-foreground-500 mt-0.5 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}